exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/* purgecss start ignore */\n.key-input{\n  position: relative;\n}\n.key-input i{\n  font-size: 18px;\n  color: #a2a2a2;\n  position: absolute;\n  left: 15px;\n  top: 29px;\n}\n\n/* purgecss end ignore */\n", ""]);

// exports
